import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Layout from "layouts/layout";
import Table from "components/table/table";
import ListContainer from "components/list/list-container";
import ListHeader from "components/list/list-header";
import _ from "lodash";
import { Profile1 } from "constants/images";
import ActionIconBtn from "components/button/action-btn";
import EditPencilIconSVG from "assets/svg/edit-pencil-icon";
import LockIconSVG from "assets/svg/lock-icon";
import UserCheckIconSVG from "assets/svg/user-check-icon";
import BlockIconSVG from "assets/svg/block-icon";
import { useDialogHook } from "utils/customhooks";
import UserInviteModal from "components/users/user-invite-modal";
import UserBlockModal from "components/users/user-block-modal";
import UserApproveModal from "components/users/user-approve-modal";
import { urlSerializer } from "utils/utils";
import {
  SET_USERS,
  GET_USERS,
  REFRESH_USERS,
  UPDATE_FEATURE
} from "redux/modules/user-management/types";
import {
  REFRESH_USERS_TRASH,
} from "redux/modules/user-trash/types";
import { useEffect } from "react";
import ToolTip from "components/tooltip/tooltip";
import UserDeleteModal from "components/users/user-delete-modal";
import TrashIconSVG from "assets/svg/trash-icon";
import UserProfile from "assets/images/image.png";
import { IoMdEye } from "react-icons/io";
import Toggle from "components/toggle/toggle";
import LoadingIndicator from "assets/svg/loading-indicator";


export default function UserManagement() {
  const { http } = global.services;

  const {
    isRequesting,
    initialize,
    loadMore,
    refresh,
    page,
    limit,
    users = [],
    pages = [],
  } = useSelector((state) => state.userManagement);

  const query = useQuery();
  const searchValue = query.get("search");
  const [filterValue, setFilterValue] = useState(searchValue);
  const [selectedRows, setSelectedRows] = useState([]);
  const modal = useDialogHook(UserInviteModal);
  const block = useDialogHook(UserBlockModal);
  const approve = useDialogHook(UserApproveModal);
  const dispatch = useDispatch();
  const deleteDialog = useDialogHook(UserDeleteModal);
  // const [isLoadingId,setLoadingId] = useState([]);

  const getUsers = async (selectedPage = null) => {
    if (isRequesting || !loadMore) return;

    dispatch({ type: GET_USERS, payload: [] });

    try {
      const url = urlSerializer("users/list", {
        search: filterValue,
        page: selectedPage ?? page,
        limit: limit,
      });
      const { data } = await http.get(url);
      const _loadMore = data.data.length > 0 ? true : false;
      // const _page = data.data.length > 0 ? page + 1 : page;
      const _page = data.current_page;
      const _lastPage = data.last_page;

      dispatch({
        type: SET_USERS,
        payload: {
          data: data.data,
          loadMore: _loadMore,
          page: _page,
          lastPage: _lastPage,
        },
      });
    } catch (err) {
      console.log("error@getUsers", err);
    }
  };

  const handleAddEdit = (data = {}) => {
    modal(data, (result) => {
      if (!_.isEmpty(result)) {
        console.log("result ", result);
        if (result === "addOrUpdate") {
          dispatch({
            type: REFRESH_USERS,
            payload: [],
          });
        }
      }
    });
  };

  const checkDomain = () => {
    const currentDomain = window.location.hostname;
    // hide in production 
    if (currentDomain.includes('milestonespage.com')) {
      return 'https://app.milestonespage.com/';
    }
    else if (currentDomain.includes('milestones.demosite.ninja')){
      return 'https://milestones.demosite.ninja/'
    }
    else{
     return 'http://localhost:3012/' 
    }
  };

  const viewProfile = (data = null) => {
  const extension = randomExtension();
    console.log(data)
    console.log(data?.user.username)
    // if (!data?.username || !data?.id) {
    //   console.error("Missing username or id for profile view.");
    //   return;
    // }

    const profileUrl = `${checkDomain()}${data?.user.username}-${extension}/profile/${data.id}`;
    
    window.open(profileUrl, "_blank");
  };


  const randomExtension = () => {
    return generateRandomAlphanumericString(4);
  };

  function generateRandomAlphanumericString(length) {
  const alphanumeric =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = alphanumeric.length;
  let result = "";

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += alphanumeric.charAt(randomIndex);
  }

  return result;
}

  const handleResetPassword = async (email) => {
    try {
      const { data } = await http.post("auth/forgot-password", { email });
      console.log("handleResetPassword", data);
    } catch (err) {
      console.log("error@handleResetPassword", err);
    }
  };

  const handleApproveUser = (data = {}) => {
    approve(data, (result) => {
      if (!_.isEmpty(result)) {
        if (result === "approve") {
          dispatch({
            type: REFRESH_USERS,
            payload: [],
          });
        }
      }
    });
  };

  const handleBlockUser = (data = {}) => {
    block(data, (result) => {
      if (!_.isEmpty(result)) {
        if (result === "block") {
          dispatch({
            type: REFRESH_USERS,
            payload: [],
          });
        }
      }
    });
  };

  const handlerDeleteUser = async(data={}) =>{
      // const { data } = await http.post("auth/forgot-password", { email });
      deleteDialog({user:data},(callback) => {
        if(callback?.success){
            dispatch({
              type: REFRESH_USERS,
              payload: [],
            });

          dispatch({
            type: REFRESH_USERS_TRASH,
            payload: [],
          });
        }
      })

  }

  const handleSearch = (e) => {
    e.preventDefault();

    dispatch({
      type: REFRESH_USERS,
      payload: [],
    });
  };

  useEffect(() => {
    if (initialize) getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, initialize]);

  const handleInputChange = async(e) => {
          const { value, id } = e.target;
          try {
              let list = [...users];
              list = list.map(item => item.id === id ? { ...item, 'feature':value ? 1 : 0 } : item)
                  console.log(list);
                  dispatch({
                      type: UPDATE_FEATURE,
                      payload: list,
                      id:id
                    });
              const data = await http.patch(`profile-feature/${id}`);
              if (data) {  
              }
            } catch (err) {
              console.log("error@handleSubmit", err);
            }finally{
            }
  };

  const columns = [
    {
      title: "Profile",
      dataIndex: "profile_name",
      nowrap: true,
      key: "profile_name",
      render: (record) => (
        <div className="w-full flex items-center">
          {record.profile_name ? (
            <div className={`w-full flex items-center hover:bg-sky-700 ${record?.user.role === 'customer' ? 'cursor-pointer' : 'cursor-not-allowed'}`} onClick={()=>viewProfile(record)}>
              <img
                src={record?.profile_image_webp_url || UserProfile}
                alt="account"
                className="account-img mr-2.5 rounded-full"
              />
              <p>
                {record.profile_name}
              </p>
            </div>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "Feature",
      dataIndex: "feature",
      nowrap: true,
      key: "feature",
      render: (record) => {
        const occupations = record?.occupations || [];
        const noOccupation = occupations.length === 0;
        const feature = Boolean(record?.feature) || false;
        return  ((record?.user.role === 'customer' &&  record.privacy === 'Public' && !noOccupation) ? 
                      <Toggle 
                        key={record.id}
                        checked={feature} 
                        onChange={(e) =>
                            handleInputChange({
                              target: {
                                name: "feature",
                                value: e?.target?.checked,
                                id:record.id
                              },
                            })
                          }
                      />
                  : (noOccupation && record?.user.role === 'customer') ? <span className="font-semibold text-red">No Occupations</span> :
                   record.privacy !== 'Public' ? <span className="font-semibold text-red">Not Public</span> : <span span className="font-semibold text-red">Admin</span>
                  )
      },
    },
    {
      title: "Occupation",
      nowrap: true,
      key: "occupation",
      render: (record) => {
        return <p className={"capitalize"}>{
          record?.occupations ?
          record?.occupations.join(', ') :
          <></>
        }</p>;
      },
    },
    {
      title: "Username",
      dataIndex: "username",
      nowrap: true,
      key: "username",
    },
    {
      title: "Type",
      dataIndex: "profile_type",
      nowrap: true,
      key: "profile_type",
      render: (record) => {
        // let color = "green";
        // if (record.role === "invited") {
        //   color = "primary";
        // }
        return <p className={"capitalize"}>{record.profile_type?.type || '--'}</p>;
      },
    },
    {
      title: "Privacy",
      dataIndex: "privacy",
      nowrap: true,
      key: "privacy",
      render: (record) => {
        return <p className={"capitalize"}>{record?.privacy || '--'}</p>;
      },
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   nowrap: true,
    //   key: "status",
    //   render: (record) => {
    //     let color = "green";
    //     if (record.status === "invited") {
    //       color = "primary";
    //     }
    //     return (
    //       <p className={`text-${color} font-bold capitalize`}>
    //         {record.status}
    //       </p>
    //     );
    //   },
    // },

    {
      title: "User Owner",
      dataIndex: "name",
      nowrap: true,
      key: "name",
      render: (record) => (
        <div className="w-full flex items-center">
          {record?.user?.first_name && record?.user?.last_name ? (
            <>
              <p>
                {record?.user?.first_name} {record?.user?.last_name}
              </p>
            </>
          ) : (
            <p>--</p>
          )}
        </div>
      ),
    },
    {
      title: "User Email",
      dataIndex: "email",
      nowrap: true,
      key: "email",
      render: (record) => (
        <div className="w-full flex items-center">
          <p>
              {record?.user?.email}
            </p>
        </div>
      ),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      hideSorting: true,
      nowrap: true,
      render: (record) => (
        <div className="flex">
          <ToolTip
            value={`Edit User`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
              <ActionIconBtn
                icon={<EditPencilIconSVG className="m-auto" />}
                onClick={() => handleAddEdit(record?.user)}
              />
          </ToolTip>
          <ToolTip
            value={`Reset Password`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              icon={<LockIconSVG className="m-auto" />}
              onClick={() => handleResetPassword(record?.user?.email)}
            />
            </ToolTip>
          {record.status !== "Verified" && (
            <ToolTip
            value={`Approve User`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
              <ActionIconBtn
                icon={<UserCheckIconSVG className="m-auto" />}
                onClick={() => handleApproveUser(record?.user)}
              />
            </ToolTip>
          )}
          <ToolTip
            value={record?.user?.status === 'blocked' ? `Unblock User` : `Block User`}
            backgroundColor="#0c6ed1"
            color="white"
            width='97px'
            >
            <ActionIconBtn
              icon={<BlockIconSVG className="m-auto" />}
              onClick={() => handleBlockUser(record?.user)}
            />
            </ToolTip>
            <ToolTip
              value={`Delete User`}
              backgroundColor="#0c6ed1"
              color="white"
              width='97px'
              >
              <ActionIconBtn
                className="action-btn"
                icon={<TrashIconSVG className="m-auto" />}
                onClick={() => handlerDeleteUser(record)}
            />
            </ToolTip>
        </div>
      ),
    },
  ];
  return (
    <Layout title="Users" routeName="users">
      <div className="main-page-wrapper">
        <ListContainer
          header={
            <ListHeader
              title="List"
              countValue={_.size(users)}
              filterValue={filterValue}
              setFilterValue={setFilterValue}
              buttonName="+ Invite User"
              showAddButton={true}
              onClickButton={() => handleAddEdit()}
              onSearch={(e) => handleSearch(e)}
            />
          }
        >
          <Table
            columns={columns}
            dataSource={users}
            pagination={true}
            // selectable={true}
            selected={selectedRows}
            onSelected={(selectedRows) => {
              setSelectedRows(selectedRows);
            }}
            perPage={10}
            currentPage={page}
            onHandleChangePage={getUsers}
            pages={pages}
          />
        </ListContainer>
      </div>
    </Layout>
  );
}

const useQuery = () => {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
};
